import type { NextPage } from 'next';
import { Box, Container, Typography } from '@mui/material';

import theme from 'src/style-system/theme';
import Footer from '@components/Footer';
import Header from '@components/Header';
import CuminButton from '@components/Button';
import ExitIntent from '@components/ExitIntent';

import { carouselContent } from './constant';
import Carousel, { ColorVariant } from '@components/Carousel';
import {
  HOW_ITS_WORK_BG_IMAGE_URL_DESKTOP,
  HOW_ITS_WORK_BG_IMAGE_URL_MOBILE,
} from '@utils/data';
import PosterSection from '@components/PosterSection';
import { faqContent } from '@containers/OrderStepOne/constant';
import FAQ from '@components/FAQ';
import PlanBanner from '@components/PlanBanner';

import MiddleSection from './MiddleSection';

const HowItWorksPage: NextPage = () => {
  const onClickChat = () => {
    //@ts-ignore
    window?.GorgiasChat?.open();
    // window?.fcWidget?.open();
  };

  return (
    <>
      {/* <ExitIntent /> */}
      <Box
        sx={{
          position: 'relative',
          backgroundImage: `url(${HOW_ITS_WORK_BG_IMAGE_URL_MOBILE})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',

          [theme.breakpoints.up('sm')]: {
            backgroundImage: `url(${HOW_ITS_WORK_BG_IMAGE_URL_DESKTOP})`,
          },
        }}
      >
        <Box sx={{ background: 'rgba(29,28,27,0.1)' }}>
          <Box
            sx={{
              background:
                'linear-gradient(180deg, #1D1C1B 0%, rgba(29, 28, 27, 0) 100%)',
            }}
          >
            <Header isBackground={false} />
            <Typography
              variant="h1"
              align="center"
              color="whitePepper.main"
              sx={{
                padding: '55px 25px 70px',
                [theme.breakpoints.up('sm')]: {
                  padding: '50px 25px 60px',
                },
              }}
            >
              How It Works
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ position: 'relative' }}>
        <MiddleSection />
        <Box
          sx={{
            position: 'sticky',
            bottom: '0px',
            boxShadow: '0px -10px 20px rgba(0, 0, 0, 0.25)',
            zIndex: 11,
          }}
        >
          <PlanBanner isTitleOnMobile={false} isSmallPadding />
        </Box>
      </Box>
      <PosterSection PosterContent={carouselContent} />

      <Box
        bgcolor="turmeric.main"
        sx={{
          padding: '60px 25px',
          [theme.breakpoints.up('lg')]: { display: 'none' },
        }}
      >
        <Carousel
          carouselContent={carouselContent}
          subtitleColor={ColorVariant.GARAMMASALA_COLOR}
          isTitleFirst
          swipeable={false}
        />
      </Box>

      <Box bgcolor="whitePepper.main">
        <Container
          maxWidth="xl"
          disableGutters
          sx={{
            padding: '50px 25px 75px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <FAQ faqContent={faqContent} />

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Typography
              variant="body1"
              align="center"
              color="cumin.main"
              mb={{ xs: '10px', md: '20px' }}
            >
              Do you still have a question?
            </Typography>
            <CuminButton
              color="turmeric"
              variant="contained"
              textColor="garamMasala.main"
              borderRadius="24"
              height="50"
              width="200px"
              onClick={onClickChat}
            >
              Chat With Us
            </CuminButton>
          </Box>
        </Container>
      </Box>
      <PlanBanner />
      <Footer />
    </>
  );
};

export default HowItWorksPage;
